import './App.css';
import './components/navbar/navbar.css';
import {Component} from "react";
import * as React from "react";

export class NavbarLink extends Component {

    menuNames = ['om_oss', 'prosess', 'team', 'kontakt_oss']

    render() {
        return (
            <div className={'default-center'}>
                <div className={'navbar-' + this.props.name}>
                    <div className={'navbar-link'}>
                        <a href={'/#/' + this.props.url} style={{ textDecoration: 'none' }}>
                            <p>{this.props.name}</p>
                            <span id={this.props.url + '-span'} className='navbar-slider'/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}


export class NavbarDropdownLink extends Component {

    menuNames = ['om_oss', 'prosess', 'team', 'kontakt_oss']

    render() {
        return (
            <div className={'default-center navbar-dropdown-link'}>
                <a href={'/#/' + this.props.url} style={{ textDecoration: 'none' }} onClick={this.props.callBack}>
                    <p>{this.props.name}</p>
                    <span id={this.props.url + '-span'} className='navbar-slider'/>
                </a>
            </div>
        )
    }
}


export class ProcessElement extends Component {
    render() {
        return (
            <div className={'process-element'}>
                <div className={'default-horizontal-center'}>
                    <img src={this.props.imageURL}/>
                </div>
                <p className={'process-element-description'}>{this.props.description}</p>
            </div>
        )
    }
}

export class ProcessElementArrow extends Component {
    render() {
        return (
            <div className={'process-element-arrow'}>
                <img src={'resources/blonomArrow.png'}/>
            </div>
        );
    }
}

export class ProcessElementArrowDown extends Component {
    render() {
        return (
            <div className={'process-element-arrow-down'}>
                <img src={'resources/blonomArrow.png'}/>
            </div>
        );
    }
}


export class ProcessSingle extends Component {
    render() {
        return (
            <div className={'default-cage default-vertical-cage'}>
                <div className={'process-single'}>
                    <Header text={this.props.header}/>
                    <p> {this.props.text} </p>
                    <img src={this.props.image}/>
                </div>
            </div>
        )
    }
}


export class Header extends Component {
    render() {
        return (
            <div className={'header'}>
                <p>{this.props.text}</p>
            </div>
        )
    }
}

export class TeamMember extends Component {
    render() {
        return (
            <div className={'team-member'}>
                <div className={'default-horizontal-center'}>
                    <img src={this.props.image} className={'team-member-image'}/>
                </div>
                <div className={'team-member-name-container'}>
                    <p className={'team-member-name'}>{this.props.name}</p>
                </div>
                <p className={'team-member-role'}><i className={'fa fa-user'}/> &nbsp; {this.props.role}</p>
                <div className={'team-member-email-container'}>
                    <p className={'team-member-email'}> {this.props.email}</p>
                    <p className={'team-member-email-icon'}><i className={'fa fa-envelope'}/></p>
                </div>
            </div>
        )
    }
}